import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover} from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import {CSVLink} from 'react-csv';


import './analytics.css';


var cc_data;

class AdPlatformCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}

	render() {
		const { loading, userTheme,opensearchAdImpressionByPlatformList } = this.props;

		cc_data = opensearchAdImpressionByPlatformList || [];
		cc_data = cc_data.map(({key, doc_count}) => ({name: key, value: doc_count}));

		const option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					top: '5%',
					left: 'center'
				},
				series: [
					{
					//name: 'Active registered users',
					type: 'pie',
					radius: ['40%', '70%'],
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 10,
						borderColor: '#fff',
						borderWidth: 2
					},
					label: {
						show: false,
						position: 'center'
					},
					emphasis: {
						label: {
						show: true,
						fontSize: 40,
						fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: cc_data
					}
				]
				};

		return (
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Ad impression by device platform  `}
					<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='AdPlatformCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map(c => ({ platforms:c.name, count:c.value}))} target="_blank" filename={"Ad impression by device platform.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	<ReactECharts style={{ height: 350, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} />
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchAdImpressionByPlatformList: state.advertisement.opensearchAdImpressionByPlatformList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdPlatformCard));
